if (!customElements.get('sticky-scroll-cta')) {
  customElements.define(
    'sticky-scroll-cta',
    class StickyScrollCta extends HTMLElement {
      connectedCallback() {
        this.mainContent = document.getElementById('MainContent');
        if (!this.mainContent) return;

        this.sectionObserver = null;
        this.heroObserver = null;

        const firstSection = this.mainContent.querySelector('.shopify-section');
        const heroes = this.mainContent.querySelectorAll('.shopify-section.custom-hero');

        const syncShow = (show) => {
          this.classList.toggle('sticky-scroll-cta--show', show);
        };

        if (heroes.length > 0) {
          this.heroIntersecting = new Map();
          heroes.forEach((hero) => this.heroIntersecting.set(hero, false));

          const updateFromHeroes = () => {
            const anyHeroInView = [...this.heroIntersecting.values()].some(Boolean);
            syncShow(!anyHeroInView);
          };

          this.heroObserver = new IntersectionObserver(
            (entries) => {
              for (const entry of entries) {
                this.heroIntersecting.set(entry.target, entry.isIntersecting);
              }
              updateFromHeroes();
            },
            { threshold: 0, root: null }
          );

          heroes.forEach((hero) => this.heroObserver.observe(hero));

          requestAnimationFrame(() => {
            heroes.forEach((hero) => {
              const r = hero.getBoundingClientRect();
              const visible =
                r.bottom > 0 &&
                r.top < window.innerHeight &&
                r.right > 0 &&
                r.left < window.innerWidth;
              this.heroIntersecting.set(hero, visible);
            });
            updateFromHeroes();
          });
          return;
        }

        if (!firstSection) {
          syncShow(true);
          return;
        }

        const updateVisibility = (entry) => {
          const top = entry.boundingClientRect.top;
          syncShow(top < 0);
        };

        this.sectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach(updateVisibility);
          },
          { threshold: [0, 0.01, 0.99, 1], root: null }
        );
        this.sectionObserver.observe(firstSection);
        requestAnimationFrame(() => {
          updateVisibility({ boundingClientRect: firstSection.getBoundingClientRect() });
        });
      }

      disconnectedCallback() {
        if (this.sectionObserver) {
          this.sectionObserver.disconnect();
          this.sectionObserver = null;
        }
        if (this.heroObserver) {
          this.heroObserver.disconnect();
          this.heroObserver = null;
        }
      }
    }
  );
}
